import { FilterGroup } from 'components/Filters/components/FilterModal'
import { FilterStore } from 'components/Filters/FilterStore'
import {
  RangeFilter,
  RangeFilterWithMinMax,
} from 'components/Filters/fields/RangeFilter'
import {
  createFilterColumnHelper,
  DataTypeColumn,
} from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { GooglePlaceChainBase } from 'models/google_place_chain'
import { ZipcodeFilter } from 'components/Filters/fields/ZipcodeFilter'
import { CityAndStateFilter } from 'components/Filters/components/CityAndStateFilter'
import { TableTypeSlug } from 'models/companies'

export function CommonFiltersetGooglePlaceGroup({
  filterStore,
  columns,
  companyType,
}: {
  filterStore: FilterStore
  columns: Record<keyof GooglePlaceChainBase, DataTypeColumn>
  companyType: TableTypeSlug
}) {
  const commonGooglePlaceFilterHelper = createFilterColumnHelper({
    columns,
  })

  return (
    <FilterGroup title="Target Attributes">
      <RangeFilter
        {...commonGooglePlaceFilterHelper.retrieveProps('doors_cnt')}
        store={filterStore}
      />
      <CityAndStateFilter
        filterStore={filterStore}
        stateSelectProps={commonGooglePlaceFilterHelper.retrieveProps(
          'state_summary'
        )}
        citySelectProps={commonGooglePlaceFilterHelper.retrieveProps(
          'city_summary'
        )}
        cityKey="city_summary"
        stateKey="state_summary"
        companyType={companyType}
      />
      <RangeFilterWithMinMax
        {...commonGooglePlaceFilterHelper.retrieveProps('reviews_avg')}
        store={filterStore}
        min={0}
        max={5}
        decimalScale={2}
      />
      <RangeFilter
        {...commonGooglePlaceFilterHelper.retrieveProps('reviews_cnt')}
        store={filterStore}
      />
      <ZipcodeFilter filterStore={filterStore} />
    </FilterGroup>
  )
}
